// Common relationships used when linking a contact to a care client.
// Picked in the Quick Contact editor so the caller panel reads clearly
// (e.g. "Jane — Daughter of Mary Smith"). "Other…" lets staff type a
// custom label when none of these fit.
export const RELATIONSHIP_OPTIONS = [
  "Daughter",
  "Son",
  "Spouse",
  "Parent",
  "Sibling",
  "Power of Attorney",
  "Guardian",
  "Caregiver",
  "Emergency Contact",
  "Friend / Neighbor",
];
